interface SavingsDetails {
  product?: {
    names?: Record<string, string>;
  };
}

interface Product {
  names?: Record<string, string>;
}

interface GetAccountProductNameProps {
  accountIsSavings: boolean;
  savingsDetails: SavingsDetails;
  userLanguage: string;
  accountTypeLabelsWeb: Record<string, string>;
  accountType: string;
  formatMessage: (key: string) => string;
}

export const getAccountProductName = ({
  accountIsSavings,
  savingsDetails,
  userLanguage,
  accountTypeLabelsWeb,
  accountType,
  formatMessage,
}: GetAccountProductNameProps): string => {
  if (accountIsSavings) {
    const getProductName = (product: Product | undefined, language: string): string =>
      product?.names?.[language] ??
      product?.names?.en_US ??
      formatMessage(accountTypeLabelsWeb[accountType] ?? accountType);

    return getProductName(savingsDetails?.product, userLanguage);
  }

  const accountTypeKey = accountTypeLabelsWeb?.[accountType] ?? accountType;
  return formatMessage(accountTypeKey);
};
